"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenCardActivationStatus = void 0;
/** @TranslateToPython */
var AvenCardActivationStatus;
(function (AvenCardActivationStatus) {
    AvenCardActivationStatus["unknown"] = "unknown";
    AvenCardActivationStatus["pending"] = "pending";
    AvenCardActivationStatus["last4DigitValidated"] = "last4DigitValidated";
    // Card had last4 validated but the validation expired (e.g. card too old for CoreCard activation).
    // Customer must re-enter last4 to refresh last4ValidatedAt before activation can proceed.
    AvenCardActivationStatus["last4DigitValidatedExpired"] = "last4DigitValidatedExpired";
    // CO created, but not processed yet. May be waiting on card or mailer code activation.
    AvenCardActivationStatus["cashOutFullDrawDrafted"] = "cashOutFullDrawDrafted";
    // Applicant has validated their mailer code and initiated the draft CO. Similar to cashOutFullDrawInProgress except that
    // the card should NOT be activated
    AvenCardActivationStatus["mailerCodeValidated"] = "mailerCodeValidated";
    AvenCardActivationStatus["activated"] = "activated";
    AvenCardActivationStatus["internalError"] = "internalError";
    /** @deprecated replaced by the table account_activation_requirement, see ActivationRequirementManager */
    AvenCardActivationStatus["_cashOutFullDrawInProgress"] = "cashOutFullDrawInProgress";
    /** @deprecated along with 'cashOutFullDrawInProgress' */
    AvenCardActivationStatus["_cashOutFullDrawError"] = "cashOutFullDrawError";
    /** @deprecated replaced by 'internalCardStatus' column with AvenCreditCardInternalStatus.closed or AvenCreditCardInternalStatus.closedInRescission */
    AvenCardActivationStatus["_closed"] = "closed";
    /** @deprecated replaced by 'internalCardStatus' column with AvenCreditCardInternalStatus.replaced */
    AvenCardActivationStatus["_canceled"] = "canceled";
    /** @deprecated replaced by 'remainingWebActivationAttempts' column */
    AvenCardActivationStatus["_exceededMaxOnlineActivationAttempts"] = "exceededMaxOnlineActivationAttempts";
})(AvenCardActivationStatus || (exports.AvenCardActivationStatus = AvenCardActivationStatus = {}));
